module.exports = __webpack_public_path__ + "img/producto-icon.ea4594c5.png";